import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {TrackStatusType} from "~~/package/mapper/track/model/TrackStatusType";

export class TrackLevelModel extends Model {
    constructor(
        public id: number = 0,
        public level: number = 0,
        public trackId: number = 0,
        public assessmentCount: number = 0,
        public progress: number = 0,
        public trackLevelTitle: string = "",
        public trackLevelDescription: string = "",
        public totalLearningTime: number = 0,
        public trackLevelUserAuth: boolean = false,
        public status: TrackStatusType = TrackStatusType.NOT_STARTED,
        public practiceStatus: TrackStatusType = TrackStatusType.NOT_STARTED,
        public courseIdList: number[] = [],
        public hasResultTemplate: boolean = false,
        public learningAssessmentFlag: boolean = false,
        public minAssessmentCount: number = 0,
        public maxAssessmentCount: number = 0,
        public minAssessmentLearningTime: number = 0,
        public maxAssessmentLearningTime: number = 0,
        public taskCount: number = 0,
        public taskLearningTime: number = 0
    ) {
        super();
    }

    public static create(model: Partial<TrackLevelModel>): TrackLevelModel {
        return createModel<TrackLevelModel>(TrackLevelModel, {
            ...model
        });
    }

    public static levelInitials = (level: number, isGeneralLevel = false) => {
        if(isGeneralLevel) return "G"
        else if (level === 0) return "E"
        else if(level === 1) return "B"
        else if(level === 2) return "I"
        else return "P"
    }

    public static levelText = (level: number, isGeneralLevel = false) => {
        if(isGeneralLevel) return "advance-level-general"
        else if (level === 0) return "advance-level-entry"
        else if(level === 1) return "advance-level-beginner"
        else if(level === 2) return "advance-level-intermediate"
        else return "advance-level-professional"
    }
}
